import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from "../../../../../core/services/menu/menu-item-forage.service";

interface IPagePb1000 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Pb1000Controller(Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass) {
    const vm: IPagePb1000 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'mvemsg', largeur: 250 }
        ]
    };
}
